var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoulette = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51045 9.00092H0C0.110628 10.9208 0.856072 12.7205 2.13542 14.1563L3.91265 12.379C3.1267 11.451 2.6167 10.2824 2.51045 9.00092Z",
    fill: "#CCD6F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91265 4.62104L2.13542 2.84381C0.856072 4.27964 0.110628 6.07924 0 7.99918H2.51045C2.6167 6.71762 3.1267 5.54904 3.91265 4.62104Z",
    fill: "#CCD6F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4896 7.99918H17.0001C16.8894 6.0793 16.144 4.27964 14.8646 2.84381L13.0874 4.62107C13.8734 5.54904 14.3834 6.71762 14.4896 7.99918Z",
    fill: "#CCD6F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4999 7.99915C8.22372 7.99915 7.99902 8.22384 7.99902 8.50003C8.0242 9.16359 8.97574 9.16343 9.00079 8.50003C9.00079 8.22381 8.77612 7.99915 8.4999 7.99915Z",
    fill: "#CCD6F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5089 8.50002C13.5089 5.73816 11.2619 3.49121 8.50005 3.49121C1.86431 3.74302 1.86611 13.258 8.50011 13.5088C11.2619 13.5088 13.5089 11.2618 13.5089 8.50002ZM11.5053 9.0009H9.91654C9.76537 9.42712 9.42714 9.76535 9.00093 9.91651V11.5053H7.99916V9.91651C7.57295 9.76535 7.23472 9.42712 7.08355 9.0009H5.49476V7.99914H7.08355C7.23472 7.57292 7.57295 7.2347 7.99916 7.08353V5.49473H9.00093V7.08353C9.42714 7.2347 9.76537 7.57292 9.91654 7.99914H11.5053V9.0009Z",
    fill: "#CCD6F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99908 2.51048V6.10352e-05C6.07921 0.110689 4.27958 0.8561 2.84375 2.13545L4.62098 3.91271C5.54897 3.12673 6.71753 2.61673 7.99908 2.51048Z",
    fill: "#CCD6F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1563 2.13548C12.7205 0.856133 10.9209 0.110689 9.00098 6.10352e-05V2.51051C10.2825 2.61676 11.4511 3.12676 12.3791 3.91271L14.1563 2.13548Z",
    fill: "#CCD6F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00098 14.4896V17.0001C10.9209 16.8894 12.7205 16.144 14.1563 14.8646L12.3791 13.0874C11.4511 13.8734 10.2825 14.3833 9.00098 14.4896Z",
    fill: "#CCD6F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 14.8646C4.27958 16.1439 6.07921 16.8894 7.99908 17V14.4895C6.71753 14.3833 5.54897 13.8733 4.62098 13.0873L2.84375 14.8646Z",
    fill: "#CCD6F4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0874 12.379L14.8646 14.1563C16.144 12.7205 16.8894 10.9208 17.0001 9.00092H14.4896C14.3834 10.2824 13.8734 11.451 13.0874 12.379Z",
    fill: "#CCD6F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoulette);
export default ForwardRef;